import type { ReactNode } from 'react';
import { TableCell, TableSortLabel } from '@mui/material';

export type Direcao = 'asc' | 'desc';
export interface Ordem<C extends string> {
  campo: C;
  dir: Direcao;
}

/** Cabeçalho de tabela clicável: o primeiro clique ordena, o segundo inverte. */
export function CabecalhoOrdenavel<C extends string>({
  campo,
  ordem,
  onOrdena,
  children,
}: {
  campo: C;
  ordem: Ordem<C>;
  onOrdena: (c: C) => void;
  children: ReactNode;
}) {
  const ativo = ordem.campo === campo;
  return (
    <TableCell sortDirection={ativo ? ordem.dir : false}>
      <TableSortLabel
        active={ativo}
        direction={ativo ? ordem.dir : 'asc'}
        onClick={() => onOrdena(campo)}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
}

/** Alterna a direção no mesmo campo; num campo novo começa pela direção padrão dele. */
export function proximaOrdem<C extends string>(
  atual: Ordem<C>,
  campo: C,
  padrao: Direcao = 'asc',
): Ordem<C> {
  return atual.campo === campo
    ? { campo, dir: atual.dir === 'asc' ? 'desc' : 'asc' }
    : { campo, dir: padrao };
}

/** Compara textos sem acento e números; vazios vão sempre para o fim. */
export function compara(a: string | number | null, b: string | number | null, dir: Direcao) {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  const c =
    typeof a === 'number' && typeof b === 'number'
      ? a - b
      : String(a).localeCompare(String(b), 'pt-BR', { sensitivity: 'base' });
  return dir === 'asc' ? c : -c;
}
